import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

import ApplicatorCompanyAPI from "../api/ApplicatorCompany.api";
import BasicShowEdit from "../components/BasicShowEdit";
import Layout from "../components/Layout";
import { ApplicatorCompany, ApplicatorCompanyInput } from "../types";

export default function ApplicatorCompanyShowPage() {
  const { id } = useParams();
  const { data: applicatorCompany } = ApplicatorCompanyAPI.useDetail(id);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Applicator</Typography>
        </Box>

        {applicatorCompany && (
          <ApplicatorCompanyForm applicatorCompany={applicatorCompany} />
        )}
      </Box>
    </Layout>
  );
}

function ApplicatorCompanyForm({
  applicatorCompany,
}: {
  applicatorCompany: ApplicatorCompany;
}) {
  const [name, setName] = React.useState<string>(applicatorCompany.name);

  const input: ApplicatorCompanyInput = {
    ...applicatorCompany,
    name,
  };

  return (
    <BasicShowEdit
      modelApiUseSave={ApplicatorCompanyAPI.useSave}
      modelApiUseDelete={ApplicatorCompanyAPI.useDelete}
      modelInput={input}
    >
      <TextField
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </BasicShowEdit>
  );
}
